const resource = '/admin/v1/provinces';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  }
});
